<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-brand">
          <img :src="county.logo || '/img/default-logo.png'" :alt="county.countyName" class="footer-logo" />
          <p>{{ formatCountyName(county.countyName) }} {{ $t('footer.copyright') }}</p>
        </div>
        <div class="footer-links">
          <a href="/#services">{{ $t('nav.services') }}</a>
          <a href="/#how-it-works">{{ $t('nav.howItWorks') }}</a>
          <a href="/#contact">{{ $t('nav.contact') }}</a>
          <a href="/#/api-docs">{{ $t('footer.apiDocs') }}</a>
        </div>
        <div class="footer-legal">
          <p>&copy; {{ currentYear }} {{ formatCountyName(county.countyName) }}.</p>
          <p class="powered" v-if="county.powered">{{ $t('footer.poweredBy') }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { authUrl, execute } from "@/api";

export default {
  name: "FooterComponent",
  data() {
    return {
      county: {
        id: null,
        countyID: null,
        countyName: null,
        logo: null,
        powered: null
      }
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  mounted() {
    this.getCounty();
  },
  methods: {
    async getCounty() {
      try {
        const data = new FormData();
        data.append("function", "getCounty");
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.county = res.data.data.county;
        }
      } catch (error) {
        console.error('Error fetching county data:', error);
      }
    },

    formatCountyName(name) {
      if (!name) return '';
      return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    }
  }
};
</script>

<style scoped>
.footer {
  background: var(--color-primary-dark);
  color: white;
  padding: 48px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.footer-logo {
  height: 40px;
  width: auto;
  filter: brightness(0) invert(1);
}

.footer-brand p {
  font-weight: 500;
}

.footer-links {
  display: flex;
  gap: 32px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: white;
}

.footer-legal {
  text-align: right;
}

.footer-legal p {
  font-size: 13px;
  opacity: 0.7;
}

.powered {
  margin-top: 4px;
}

/* Responsive */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
  }
  
  .footer-brand {
    flex-direction: column;
  }
  
  .footer-legal {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 16px;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 16px;
  }
}
</style>
